import React from 'react';
import { getWSUrl } from '../functions';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
class LoginPopup extends AbstractWelcomePage {
    constructor(props) {
        super(props);
        this.handlePasswordKeyPress = (event) => {
            if (event.key === 'Enter') {
                this._onLogin();
            }
        };
        this.state = {
            ...this.state,
            loginResult: ''
        };
        this.email = React.createRef();
        this.password = React.createRef();
        this.divError = React.createRef();
    }
    componentDidMount() {
        this.email.current?.focus();
    }
    ShowSecond() {
        var divErrore = this.divError;
        if (divErrore.current !== null)
            divErrore.current.className = "showMessaggiPopup";
        setTimeout(function () { if (divErrore.current !== null)
            divErrore.current.className = "hideMessaggiPopup"; }, 2000);
    }
    _onLogin() {
        this.setState({ loginResult: "" });
        this.ShowSecond();
        // Call to internal service due to CORS rules
        fetch("https://" + getWSUrl() + "/loginMeet", {
            method: "POST",
            headers: {
                'Content-Type': 'text/plain'
            },
            body: JSON.stringify({
                username: this.email.current?.value,
                password: this.password.current?.value,
                appName: "Meeting"
            })
        })
            .then(res => res.json())
            .then((result) => {
            var etichetta = "LoginPopup." + result.result;
            //console.log("MS ----->    MESSAGGIO: ", result.msg);
            this.setState({ loginResult: this.props.t(etichetta) });
            this.props.cambiaStatoLogin(result); //Porto in WelcomePage il cambiamento di stato della login
            if (result.result == 1) {
                location.href = 'https://' + location.hostname;
                this.props.closePopup;
            }
        }, (error) => {
            this.setState({ loginResult: this.props.t('LoginPopup.erroreGenerico') });
        });
    }
    render() {
        return (React.createElement("div", { className: 'modal' },
            React.createElement("div", { className: 'modal-content' },
                React.createElement("span", { className: "close", onClick: this.props.closePopup }, " \u00D7 "),
                React.createElement("h1", { className: "testoPopup" },
                    " ",
                    this.props.t('LoginPopup.intestazione'),
                    " "),
                React.createElement("h4", { className: "testoPopup" },
                    " ",
                    this.props.t('LoginPopup.inserisciCredenziali'),
                    " "),
                React.createElement("div", null,
                    React.createElement("input", { type: "text", name: "email", placeholder: "email", ref: this.email, onKeyPress: this.handlePasswordKeyPress })),
                React.createElement("br", null),
                React.createElement("div", null,
                    React.createElement("input", { type: "password", name: "password", placeholder: "password", ref: this.password, onKeyPress: this.handlePasswordKeyPress })),
                React.createElement("div", { id: "divErrore", className: "hideMessaggiPopup", ref: this.divError },
                    React.createElement("p", { ref: "errore", className: "messaggiPopup" },
                        " ",
                        this.state.loginResult,
                        " ")),
                React.createElement("br", null),
                React.createElement("button", { className: "buttonWI", name: "buttonLogin", onClick: () => { this._onLogin(); } },
                    " ",
                    this.props.t('LoginPopup.accedi'),
                    " "),
                "  ",
                React.createElement("br", null),
                React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
                    React.createElement("small", { className: "news" },
                        " ",
                        this.props.t('LoginPopup.passwordDimenticata1')),
                    " ",
                    React.createElement("a", { className: "showNewFeatures", target: "_black", href: "https://areaclienti.vianova.it/#passwordRecovery" }, this.props.t('LoginPopup.passwordDimenticata2'))))));
    }
}
//export default LoginPopup;
export default translate(connect(_mapStateToProps)(LoginPopup));
